import { render, staticRenderFns } from "./IndexTrade.vue?vue&type=template&id=789a24cd&scoped=true"
import script from "./IndexTrade.vue?vue&type=script&lang=js"
export * from "./IndexTrade.vue?vue&type=script&lang=js"
import style0 from "./IndexTrade.vue?vue&type=style&index=0&id=789a24cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789a24cd",
  null
  
)

export default component.exports